import {Breakpoints, styled} from '@vw-marketing/us-components';

export const StyledDealer: any = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
  padding-top: calc(
    (${(props) => props?.theme?.textAppearances?.headline0200?.lineHeight}) / 2
  );
`;

export const StyledDealerName: any = styled.div`
  margin-bottom: 5px;

  @media (min-width: ${Breakpoints.b960}px) {
    width: 65%;
  }
`;

export const StyledDealerLocation: any = styled.div`
  display: grid;
  grid-template-columns: min-content;
  column-gap: 10px;
  margin: 5px 0;
  grid-template-areas: 'icon address' 'icon location';

  svg {
    grid-area: icon;
    color: #001d50;
    margin-top: 2.5px;
  }
`;

export const StyledDealerContact: any = styled.span`
  width: max-content;
  display: flex;
  align-items: center;
  column-gap: 8px;

  svg {
    color: #001d50;
  }
`;

export const StyledButton: any = styled.div`
  display: block;
  margin: 0 auto;
  margin-top: 28px;
  max-height: 44px;
  width: 92%;

  button {
    width: 100%;

    &:focus {
      outline: none;
    }
  }

  @media (min-width: ${Breakpoints.b1280}px) {
    width: 84%;
    margin-top: 40px;
  }
`;

export const StyledMapsImage: any = styled.span`
  cursor: pointer;
  width: 100%;
`;

export const StyledDealerNameMiles: any = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 20px;

  @media (min-width: ${Breakpoints.b960}px) {
    flex-direction: row;
  }
`;

export const StyledDealerSite: any = styled.span`
  cursor: pointer;
  display: flex;
  align-items: flex-end;

  > a {
    display: flex;
    flex-direction: row;
  }

  svg {
    margin-left: 6px;
    margin-top: 2px;
  }
`;

export const StyledDealerContactPhoneSite: any = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const StyledInfoWrapper: any = styled.div`
  border: solid 1px #cfcfcf;
  border-top: none;
  border-bottom-right-radius: 2%;
  border-bottom-left-radius: 2%;
  padding: 20px 6% 30px;
  width: 100%;

  @media (min-width: ${Breakpoints.b1280}px) {
    padding-bottom: 40px;
  }
`;
